module.exports = __webpack_public_path__ + "static/media/visa.32296a7f.png";